import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["companyId"],
  _excluded2 = ["companyId", "senderId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';
import { billingDashboardBaseUrl } from '../bills/routes';
import { billAutomationAllowedSendersRoutes } from './routes';

/** The two match kinds the service accepts — by NAME; it refuses the numeric enum values. */

/**
 * Partial update: only the fields present change. The matched value is immutable on the service —
 * a row's identity is what it matches — so fixing a typo is delete + add.
 */

export class BillAutomationAllowedSenders {
  constructor() {
    _defineProperty(this, "routes", billAutomationAllowedSendersRoutes);
  }
  /** Every row, active and disabled — the service sorts domains first. */
  async getAllowedSenders(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.BILL_AUTOMATION).get(this.routes.companySenders(data.companyId), _objectSpread({
      baseURL: billingDashboardBaseUrl
    }, options.cancelToken));
    return resp.data;
  }
  async addAllowedSender(data, options) {
    const companyId = data.companyId,
      body = _objectWithoutProperties(data, _excluded);
    const resp = await requestService(API_SERVICE_NAMES.BILL_AUTOMATION).post(this.routes.companySenders(companyId), body, _objectSpread({
      baseURL: billingDashboardBaseUrl
    }, options.cancelToken));
    return resp.data;
  }
  async updateAllowedSender(data, options) {
    const companyId = data.companyId,
      senderId = data.senderId,
      body = _objectWithoutProperties(data, _excluded2);
    const resp = await requestService(API_SERVICE_NAMES.BILL_AUTOMATION).patch(this.routes.companySender(companyId, senderId), body, _objectSpread({
      baseURL: billingDashboardBaseUrl
    }, options.cancelToken));
    return resp.data;
  }
  async deleteAllowedSender(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.BILL_AUTOMATION).delete(this.routes.companySender(data.companyId, data.senderId), _objectSpread({
      baseURL: billingDashboardBaseUrl
    }, options.cancelToken));
    return resp.data;
  }
}